var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":"https://senhadigital.com.br/htmlpages/compatibilidade/index.html","width":"100%","height":"1190px","scrolling":"no"}})])
}]

export { render, staticRenderFns }